import classNames from 'classnames'
import { motion } from 'framer-motion'

export enum ReceiverTab {
  gateways = 'gateways',
  all = 'all',
  up = 'up',
  upDown = 'upDown',
  down = 'down',
  buffer = 'buffer'
}

interface IProps {
  currentTab: string
  setTab: (tab: ReceiverTab) => void
}

export const ReceiverTabsHeader: React.FC<IProps> = ({ currentTab, setTab }) => (
  <div className='w-full sm:w-auto inline-block bg-primary rounded-3xl'>
    <div className='h-[40px] sm:h-[40px] bg-primary-content/5 text-primary-content flex items-center justify-evenly rounded-3xl px-[5px]'>
      <motion.button
        type='button'
        onClick={() => setTab(ReceiverTab.gateways)}
        // animate={{
        //   backgroundColor: currentTab === ReceiverTab.gateways ? 'hsla(var(--pc))' : 'transparent',
        //   transition: {
        //     ease: 'easeInOut',
        //     duration: 5
        //   }
        // }}
        className={classNames(
          'grow h-[30px] sm:h-[40px] px-[15px] flex items-center justify-center rounded-3xl text-[0.9em]',
          currentTab === ReceiverTab.gateways && 'bg-primary-content/30'
        )}
      >
        Gateways
      </motion.button>
      <motion.button
        type='button'
        onClick={() => setTab(ReceiverTab.all)}
        // animate={{
        //   backgroundColor: currentTab === ReceiverTab.up ? 'hsla(var(--pc))' : 'transparent',
        //   transition: {
        //     ease: 'easeInOut',
        //     duration: 5
        //   }
        // }}
        className={classNames(
          'grow h-[30px] sm:h-[40px] px-[15px] flex items-center justify-center rounded-3xl text-[0.9em]',
          currentTab === ReceiverTab.all && 'bg-primary-content/30'
        )}
      >
        All
      </motion.button>
      <motion.button
        type='button'
        onClick={() => setTab(ReceiverTab.up)}
        // animate={{
        //   backgroundColor: currentTab === ReceiverTab.up ? 'hsla(var(--pc))' : 'transparent',
        //   transition: {
        //     ease: 'easeInOut',
        //     duration: 5
        //   }
        // }}
        className={classNames(
          'grow h-[30px] sm:h-[40px] px-[15px] flex items-center justify-center rounded-3xl text-[0.9em]',
          currentTab === ReceiverTab.up && 'bg-primary-content/30'
        )}
      >
        Up
      </motion.button>
      <motion.button
        type='button'
        onClick={() => setTab(ReceiverTab.upDown)}
        // animate={{
        //   backgroundColor: currentTab === ReceiverTab.upDown ? 'hsla(var(--pc))' : 'transparent',
        //   transition: {
        //     ease: 'easeInOut',
        //     duration: 5
        //   }
        // }}
        className={classNames(
          'grow h-[30px] sm:h-[40px] px-[15px] flex items-center justify-center rounded-3xl text-[0.9em]',
          currentTab === ReceiverTab.upDown && 'bg-primary-content/30'
        )}
      >
        Up/Down
      </motion.button>
      <motion.button
        type='button'
        onClick={() => setTab(ReceiverTab.down)}
        // animate={{
        //   backgroundColor: currentTab === ReceiverTab.down ? 'hsla(var(--pc))' : 'transparent',
        //   transition: {
        //     ease: 'easeInOut',
        //     duration: 5
        //   }
        // }}
        className={classNames(
          'grow h-[30px] sm:h-[40px] px-[15px] flex items-center justify-center rounded-3xl text-[0.9em]',
          currentTab === ReceiverTab.down && 'bg-primary-content/30'
        )}
      >
        Down
      </motion.button>
    </div>
  </div>
)
